import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { LogoMark } from "@/components/Logo";

export default function SlideTitle({ goTo }) {
  return (
    <section className="relative min-h-[calc(100vh-7rem)] px-6 md:px-14 lg:px-20 py-10 md:py-14 flex flex-col">
      <div className="flex items-center justify-between text-[11px] uppercase tracking-brand text-muted-foreground font-mono-data">
        <LogoMark className="h-8 w-auto" />
        <span>Cover</span>
      </div>

      <div className="flex-1 flex flex-col justify-center max-w-6xl mt-10">
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}
          className="overline mb-8 flex items-center gap-3"
        >
          <Sparkles className="w-3.5 h-3.5" strokeWidth={1.5} />
          AI-Enhanced · Unsecured Consumer + RISC
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
          className="font-display text-[14vw] md:text-[10vw] lg:text-[8.5vw] leading-[0.88] tracking-tighter font-medium"
        >
          Modern<br />
          <span className="italic">servicing,</span><br />
          <span className="text-primary">reimagined.</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-10 font-display text-2xl md:text-3xl leading-snug max-w-3xl text-foreground/80"
        >
          You don't just need technology — you need a <em className="italic text-primary">trusted team</em> and technology. Fast. Flexible. Operator-led. With a transparent flat-fee model.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.9, duration: 0.6 }}
          className="mt-14 flex flex-wrap items-center gap-8"
        >
          <button
            data-testid="cover-cta-next"
            onClick={() => goTo(1)}
            className="btn-primary"
          >
            Begin Walkthrough <ArrowRight className="w-4 h-4" />
          </button>
          <button
            data-testid="cover-cta-calc"
            onClick={() => goTo(11)}
            className="btn-ghost"
          >
            Jump to Savings Calculator
          </button>
        </motion.div>
      </div>

      <div className="mt-16 grid grid-cols-3 border-t border-foreground/20 pt-6 text-xs font-mono-data">
        <div><span className="text-muted-foreground block overline mb-2">Pricing</span>$3 / acct · flat</div>
        <div><span className="text-muted-foreground block overline mb-2">Platform</span>Powered by LoanPro</div>
        <div><span className="text-muted-foreground block overline mb-2">Compliance</span>CompliSun-ready</div>
      </div>

      <p className="mt-8 pt-4 border-t border-foreground/10 text-[10px] font-mono-data text-muted-foreground/80 leading-relaxed">
        All figures and examples in this deck are for illustrative purposes only and do not constitute a guaranty, warranty, or prediction of future performance.
      </p>
    </section>
  );
}
